<template>
    <!-- 单图热点层 -->
     <div class="imagesWrap topbox">
      <img :src="imagesData.data[imagesData.imagesIndex]" >
      <div class="closeBtns" @click="clickCloseImages">
          <!-- <svg t="1586328754163" class="icon closeBtnBj" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9943" width="200" height="200"><path d="M71.675 962l-9.675-900 890.325 900z" p-id="9944" fill="#d81e06"></path></svg>
          <svg t="1586328854214" class="icon closeBtn" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10841" width="200" height="200"><path d="M153.998 113.778l756.224 756.224-40.22 40.22-756.224-756.224z" fill="#e6e6e6" p-id="10842"></path><path d="M870.002 113.778l40.22 40.22-756.224 756.224-40.22-40.22z" fill="#e6e6e6" p-id="10843"></path></svg>  -->
          <img src="../assets/images/goback_btn.png" class="topbox_clost animated flash infinite">
      </div>
     </div>
    <!-- 单图热点层 -->
</template>

<style type="text/css">
  .imagesWrap{ width: 100%; height: 100vh;  background-color: rgba(0,0,0,0.8); position: fixed; z-index: 9999; top:0; left:0;   align-items: flex-start!important;    overflow-y: scroll;
    overflow-x: hidden;}
    .topbox_clost{    position: fixed;
    top: 1.00rem;
    left: 0.55rem;
    width: 0.72rem!important;}
  .imagesWrap img{ width: 7rem; }
   @media screen and (max-width: 450px) {
        .imagesWrap img{ width: 100%; }
  } 
</style>
<script type="text/javascript">
	export default{
		name:'imageBox',
		props:['imagesData'],
		data(){
			return {
			}
		},
		mounted (){
		},
		methods:{
            clickCloseImages(){
                this.$emit('clickCloseImages');
            }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/imageBox.vue